module.exports = __webpack_public_path__ + "static/testi-10-e84170fe13ecb0a0c46acce88872427c.jpg";